import { captureOrReadMarketingAttribution } from './MarketingAttribution';

export const GTM_CONTAINER_ID = 'GTM-PK9V24BF';

export const initializeMarketingMeasurement = ({
  hostname = typeof window !== 'undefined' ? window.location.hostname : '',
  documentObject = typeof document !== 'undefined' ? document : null,
  dataLayer = typeof window !== 'undefined' ? (window.dataLayer = window.dataLayer || []) : null,
} = {}) => {
  captureOrReadMarketingAttribution();

  if (hostname !== 'app.apcentral.net' || !documentObject || !dataLayer) return false;
  if (documentObject.querySelector(`script[data-ademero-gtm="${GTM_CONTAINER_ID}"]`)) return true;

  dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const script = documentObject.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}`;
  script.dataset.ademeroGtm = GTM_CONTAINER_ID;
  documentObject.head.appendChild(script);
  return true;
};
